<section class="sbnb-onboarding">
  <sbnb-signup-header></sbnb-signup-header>

  <article *ngIf="stage === 1" class="main" id="signup-ask-for-email">
    <sbnb-partner-discount-details-banner
      *ngIf="partnerDiscountCode"
      [code]="partnerDiscountCode"
      style="margin-bottom: 60px"></sbnb-partner-discount-details-banner>
    <header>
      <h2 class="nomargin">Hello there</h2>
    </header>
    <section class="content">
      <p class="subheader">Please enter your email address to get started.</p>

      <form [formGroup]="stage1Form">
        <label for="email" [class.rose]="emailError">Email {{ emailError ? ' - ' + emailError : '' }}</label>

        <mat-form-field fxFlex>
          <input
            matInput
            formControlName="email"
            [placeholder]="wizard.emailPlaceholder"
            (input)="ifExistingRevertToNew()" />
        </mat-form-field>

        <button
          *ngIf="wizard.signupUser.status === 'existing'"
          mat-flat-button
          class="next-step"
          [routerLink]="['/user/hello', this.wizard.signupUser.email]">
          Take me to login
        </button>

        <button
          *ngIf="wizard.signupUser.status === 'invited'"
          mat-flat-button
          class="next-step"
          (click)="guideInvited()">
          Please guide me
        </button>

        <button
          *ngIf="wizard.signupUser.status === 'new'"
          mat-flat-button
          [disabled]="!stage1Form.valid || validatingEmail"
          class="next-step"
          id="signup-welcome-initial-continue-btn"
          (click)="validateEmail(stage1Form.get('email').value)">
          <mat-spinner *ngIf="validatingEmail" class="button__spinner" [diameter]="30"></mat-spinner>
          <span>Continue</span>
        </button>
      </form>

      <ng-container *ngIf="wizard.signupUser.status === 'new' && shouldShowAirbnbSignup">
        <span class="hr-or">or</span>

        <div
          class="continue-with-airbnb"
          [ngClass]="{
            'has-airbnb-error': airbnbSignUpError
          }">
          <sbnb-button
            [loading]="(signUpWithAirbnbLoadingState$ | async) === LoadingState.Pending"
            [fullWidth]="true"
            type="secondary"
            (clicked)="signUpWithAirbnb()">
            <sbnb-icon-airbnb fxFlex="0 0 20px" [size]="20"></sbnb-icon-airbnb>
            <span>Continue with Airbnb</span>
          </sbnb-button>

          <div *ngIf="airbnbSignUpError" class="error-message">
            <span *ngIf="airbnbSignUpErrorMessage$ | async as airbnbSignUpErrorMessage">
              {{ airbnbSignUpErrorMessage }}
            </span>
            <span *ngIf="!(airbnbSignUpErrorMessage$ | async)">
              Sorry something went wrong during the Airbnb signup, please try again or continue with email.
            </span>
          </div>
        </div>
      </ng-container>
    </section>
  </article>

  <article *ngIf="stage === 2" class="main" id="signup-ask-for-personal">
    <header fxLayout fxLayoutGap="16px">
      <img
        class="user-avatar"
        fxFlex="64px"
        [src]="wizard.signupUser.avatar"
        onerror="this.src='/assets/images/signup/avatar.svg'" />
      <div fxLayout="column" fxLayoutGap="0px">
        <h2 *ngIf="!wizard.signupUser.first_name">Hello there</h2>
        <h2 *ngIf="wizard.signupUser.first_name">
          {{ wizard.signupUser.first_name }} {{ wizard.signupUser.last_name }}
        </h2>
        <span>Welcome to {{ 'CORE.PRODUCT_NAME' | transloco }}</span>
      </div>
    </header>

    <form [formGroup]="stage2Form" style="margin-top: 24px">
      <label for="email" [class.rose]="emailError">
        Email
        {{ emailError ? ' - ' + emailError : '' }}

        <ng-container *ngIf="isAirbnbSignup && !emailError">- You can change your email later.</ng-container>
      </label>

      <mat-form-field fxFlex>
        <input matInput formControlName="email" [placeholder]="wizard.emailPlaceholder" />
      </mat-form-field>

      <div fxLayout fxLayout.lt-lg="column" fxLayoutGap="20px" fxLayoutGap.lt-lg="">
        <div fxLayout="column" fxFlex="172px" fxFlex.lt-lg="auto">
          <label for="first_name">First name</label>

          <mat-form-field fxFlex>
            <input matInput formControlName="first_name" placeholder="Eg. John" />
          </mat-form-field>
        </div>

        <div fxLayout="column" fxFlex="172px" fxFlex.lt-lg="auto">
          <label for="last_name">Last name</label>

          <mat-form-field fxFlex>
            <input matInput formControlName="last_name" placeholder="Eg. Doe" />
          </mat-form-field>
        </div>
      </div>

      <label for="mobile_phone">Mobile number</label>

      <mat-form-field class="fw">
        <ngx-mat-intl-tel-input
          [enablePlaceholder]="true"
          [preferredCountries]="preferredCountries"
          [enableSearch]="true"
          name="mobile_phone"
          formControlName="mobile_phone"
          #phone></ngx-mat-intl-tel-input>
        <mat-hint>Eg. {{ phone.selectedCountry.placeHolder }}</mat-hint>
      </mat-form-field>

      <div style="margin-top: 12px" *ngIf="!isAirbnbSignup">
        <mat-checkbox formControlName="agreed_to_tos">
          <span class="text__small">
            I agree to the
            <a href="{{ config.TOS_URL }}" target="_blank" class="strong" target="_blank">Terms of Service</a>
            and
            <a href="{{ config.PRIVACY_POLICY_URL }}" target="_blank" class="strong" target="_blank">Privacy Policy</a>
          </span>
        </mat-checkbox>
      </div>
    </form>

    <re-captcha
      #captchaRef="reCaptcha"
      siteKey="6LfeJaQUAAAAAIQ_vByLDLtykLj658FY9Fh4CYBs"
      size="invisible"
      (resolved)="
        $event &&
          createNewUser(
            stage2Form.get('email').value,
            stage2Form.get('first_name').value,
            stage2Form.get('last_name').value,
            stage2Form.get('mobile_phone').value,
            stage2Form.get('agreed_to_tos').value,
            $event
          )
      "></re-captcha>

    <button
      style="width: 100%"
      mat-flat-button
      [disabled]="!stage2Form.valid || submittingStage2"
      class="next-step"
      (click)="checkCaptcha()">
      <mat-spinner *ngIf="submittingStage2" class="button__spinner" [diameter]="30"></mat-spinner>
      <span>Continue</span>
    </button>
  </article>

  <article *ngIf="stage === 3" class="main" id="signup-returning">
    <header fxLayout fxLayoutGap="16px">
      <img
        class="user-avatar"
        fxFlex="64px"
        [src]="wizard.signupUser.avatar"
        onerror="this.src='/assets/images/signup/avatar.svg'" />
      <div fxLayout="column" fxLayoutGap="0px">
        <h2 *ngIf="!wizard.signupUser.first_name">Hello there</h2>
        <h2 *ngIf="wizard.signupUser.first_name">
          {{ wizard.signupUser.first_name }} {{ wizard.signupUser.last_name }}
        </h2>
        <span>Welcome back to {{ 'CORE.PRODUCT_NAME' | transloco }}!</span>
      </div>
    </header>

    <p *ngIf="!leftOffLoaded">
      You can continue your sign up process where you last left off or you can start over if you wish.
    </p>

    <p *ngIf="leftOffLoaded">
      We have just sent a magic link to your email
      <span *ngIf="wizard.signupUser?.email" class="raspberry-darker">{{ wizard.signupUser.email }}</span>
      .
    </p>

    <p *ngIf="leftOffLoaded">Check your inbox and click the link in the mail to resume your registration.</p>

    <div *ngIf="!leftOffLoaded" fxLayout="column" fxLayoutGap="12px">
      <button
        [disabled]="leftOffLoading || startingOver"
        mat-flat-button
        class="next-step fw"
        (click)="goBackToWhereILeftOff()">
        <mat-spinner *ngIf="leftOffLoading" [diameter]="30" class="button__spinner"></mat-spinner>
        Go back to where I left off
      </button>

      <button
        mat-flat-button
        [disabled]="leftOffLoading || startingOver"
        class="button__secondary fw"
        (click)="startOver()">
        <mat-spinner *ngIf="startingOver" [diameter]="30" class="button__spinner"></mat-spinner>
        Start over
      </button>
    </div>
  </article>

  <aside *ngIf="stage === 1" class="testimonials" fxHide.lt-md style="max-height: 100vh; overflow: hidden">
    <div *ngFor="let chunk of chunkedTestimonials; let i = index">
      <section class="ribbon">
        <a *ngFor="let t of chunkedTestimonials[i]" style="cursor: initial">
          <header>{{ t.title }}</header>
          <p class="review_text">{{ t.review }}</p>

          <a [href]="t.review_url" target="_blank">
            <footer fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
              <img [src]="'/assets/images/signup/review-platforms/' + t.platform + '.svg'" [alt]="t.platform" />
              <div fxLayout="column" fxLayoutAlign="start start">
                <span class="text__small">{{ t.user.name }}</span>
                <img src="/assets/images/signup/5-stars.svg" alt="5 star" />
              </div>
            </footer>
          </a>
        </a>
      </section>
    </div>
  </aside>

  <aside *ngIf="stage > 1" fxHide.lt-md>
    <span class="metric-section-label">Some quick facts:</span>
    <section class="metric-section">
      <sbnb-overview-box
        fxFlex
        [title]="'14,762,439'"
        subtitle="Messages sent to guests using Hospitable.com in the past year alone"></sbnb-overview-box>
      <sbnb-overview-box
        fxFlex
        [title]="'92,897'"
        subtitle="Properties currently being managed using Hospitable.com automation features"></sbnb-overview-box>
    </section>
    <section class="metric-section">
      <sbnb-overview-box
        fxFlex
        [title]="'14,258'"
        subtitle="Hosts rely on Hospitable.com to run their rental business"></sbnb-overview-box>
      <sbnb-overview-box
        fxFlex
        [title]="'28,333,222'"
        subtitle="Reservations that have been managed by hosts using Hospitable.com"></sbnb-overview-box>
    </section>
  </aside>
</section>
